// Modules
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { A11y, Autoplay, Navigation, Pagination } from "swiper";
import { SwiperSlide, Swiper } from "swiper/react";
// Styles
import Styles from "./Styles/Footer.module.css";
// Images
import eitaLogo from "../../../Assets/Icons/eitaa-logo-black.png";
import gmailIcon from "../../../Assets/Icons/gmail-logo-black.png";
import instagramLogo from "../../../Assets/Icons/instagram-logo-black.png";
import telegramImage from "../../../Assets/Icons/telegram.png";
import facebookImage from "../../../Assets/Icons/facebook.png";
import enamadImg from "../../../Assets/Icons/enamad-1star.png";
import samandehi from "../../../Assets/Icons/samandehi.png";
import parvaneNashrImg from "../../../Assets/Icons/parvane-nashre-digital.jpg";
import mojavezImg from "../../../Assets/Images/mojavez-parvane-nashr.jpg";
// API
import { createNewsSubscription } from "../../../Services/usersService";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [showMojavez, setShowMojavez] = useState(false);

  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleRegisterNewsSubscription = (e) => {
    e.preventDefault();
    if (email.length > 0 && isEmailValid(email)) {
      toast.promise(createNewsSubscription({ email }), {
        loading: "در حال ارسال درخواست عضویت . . .",
        success: (res) => {
          setEmail("");
          return res.data.message;
        },
        error: (res) => res.response.data.message,
      });
    } else {
      toast.error("لطفا یک ایمیل معتبر وارد کنید");
    }
  };

  return (
    <div className={Styles.container}>
      <Lightbox
        open={showMojavez}
        close={() => setShowMojavez(false)}
        slides={[{ src: mojavezImg }]}
      />
      <div className={Styles.left}>
        <div>
          <h2>
            شبکه‌های اجتماعی هُرمه سریع‌ترین روش دسترسی به مطالب مختلف است
          </h2>
          <h2>
            اگر می‌خواهید به‌روز باشید، شبکه‌های اجتماعی هُرمـه را دنبال کنید
          </h2>
        </div>
        <div className={Styles.social}>
          <Link to="">
            <img src={telegramImage} alt="" />
          </Link>
          <a
            href="https://www.instagram.com/horme.education/?utm_source=ig_web_button_share_sheet&igshid=MmVlMjlkMTBhMg=="
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagramLogo} alt="" />
          </a>
          <a href="https://eitaa.com/Horme_ir" target="_blank" rel="noreferrer">
            <img src={eitaLogo} alt="" />
          </a>
          <a
            href="mailto:horme.operator1@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <img src={gmailIcon} alt="" />
          </a>
          <Link to="">
            <img src={facebookImage} alt="" />
          </Link>
        </div>
      </div>
      <div className={Styles.center}>
        <a
          referrerPolicy="origin"
          target="_blank"
          rel="noreferrer"
          href="https://trustseal.enamad.ir/?id=387572&Code=U5lIXYBIjkbrNB7fvZrqKPSqEuXscoY5"
        >
          <img
            referrerPolicy="origin"
            src={enamadImg}
            alt=""
            style={{ cursor: "pointer" }}
            code="U5lIXYBIjkbrNB7fvZrqKPSqEuXscoY5"
          />
        </a>
        <a
          href="https://logo.samandehi.ir/Verify.aspx?id=365813&p=xlaogvkadshwmcsirfthxlao"
          referrerPolicy="origin"
          target="_blank"
          style={{ color: "black" }}
        >
          <img
            referrerPolicy="origin"
            id="rgvjfukzapfuoeukjxlzrgvj"
            alt="logo-samandehi"
            // src="https://logo.samandehi.ir/logo.aspx?id=365813&p=qftiwlbqujynaqgwnbpdqfti"
            src={samandehi}
          />
        </a>
        <div
          className={Styles.parvaneNashr}
          onClick={() => setShowMojavez(true)}
        >
          <img
            src={parvaneNashrImg}
            alt="مجوز پروانه نشر دیجیتال"
            style={{ cursor: "pointer" }}
          />
        </div>
        {/* <Swiper
        direction="horizontal"
        modules={[
          A11y,
          Autoplay,
          // ,Navigation, Pagination
        ]}
        spaceBetween={0}
        grabCursor={true}
        slidesPerView={1}
        pagination={{
          clickable: true,
        }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        className={Styles.center}
      >
        <SwiperSlide className={Styles.singleTextContainer}>
          <a
            referrerPolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=387572&Code=U5lIXYBIjkbrNB7fvZrqKPSqEuXscoY5"
          >
            <img
              referrerPolicy="origin"
              src={enamadImg}
              alt="اینماد"
              style={{ cursor: "pointer" }}
              code="U5lIXYBIjkbrNB7fvZrqKPSqEuXscoY5"
            />
          </a>
        </SwiperSlide>
        <SwiperSlide className={Styles.singleTextContainer}>
          <a
            href="https://logo.samandehi.ir/Verify.aspx?id=365813&p=xlaogvkadshwmcsirfthxlao"
            referrerPolicy="origin"
            target="_blank"
            style={{ color: "black" }}
          >
            <img
              referrerPolicy="origin"
              id="rgvjfukzapfuoeukjxlzrgvj"
              alt="logo-samandehi"
              // src="https://logo.samandehi.ir/logo.aspx?id=365813&p=qftiwlbqujynaqgwnbpdqfti"
              src={samandehi}
            />
          </a>
        </SwiperSlide>
        <SwiperSlide className={Styles.singleTextContainer}>
          <div
            className={Styles.parvaneNashr}
            onClick={() => setShowMojavez(true)}
          >
            <img
              src={parvaneNashrImg}
              alt="مجوز پروانه نشر دیجیتال"
              style={{ cursor: "pointer" }}
            />
          </div>
        </SwiperSlide>
      </Swiper> */}
      </div>
      <div className={Styles.right}>
        <div className={Styles.top}>
          <h4>عضویت در خبرنامه</h4>
          <div className={Styles.informationContainer}>
            <div
              onClick={handleRegisterNewsSubscription}
              className={Styles.button}
            >
              عضویت
            </div>
            <input
              value={email}
              onChange={handleChangeEmail}
              type="email"
              placeholder="ایمیل خود را وارد کنید"
            />
          </div>
        </div>
        <div className={Styles.separator}></div>
        <h4 className={Styles.bottom}>تنفسی عمیق در جهان آموزش</h4>
      </div>
    </div>
  );
};

export default Footer;
